module.exports = __webpack_public_path__ + "static/img/wdsjtb1-3.3893a89.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdsjtb1-3.png
// module id = 871
// module chunks = 0